import { cn } from '../../lib/utils'

interface SponsorMonogramProps {
  sponsor: string | null
  className?: string
  textClassName?: string
}

export function SponsorMonogram({ sponsor, className, textClassName }: SponsorMonogramProps) {
  const initials = (sponsor ?? 'DST').slice(0, 2).toUpperCase()
  return (
    <div
      className={cn(
        'flex items-center justify-center w-full h-full',
        'bg-gradient-to-br from-primary/20 to-primary/5',
        className
      )}
      aria-hidden="true"
    >
      <span
        className={cn(
          'font-serif text-6xl font-bold text-primary/60 select-none',
          textClassName
        )}
      >
        {initials}
      </span>
    </div>
  )
}
